import React, { useState, useEffect } from 'react';
import WatchlistSidebar from './WatchlistSidebar';
import WatchlistTable from './WatchlistTable';
import { useAppData } from '../../context/AppContext';

export default function WatchlistView() {
  const { watchlists } = useAppData();
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    if (watchlists.length > 0 && !activeId) {
      setActiveId(watchlists[0].id);
    }
  }, [watchlists, activeId]);

  const activeList = watchlists.find(w => w.id === activeId);

  return (
    <div className="flex h-full">
      <WatchlistSidebar activeId={activeId} setActiveId={setActiveId} />
      <WatchlistTable activeList={activeList} />
    </div>
  );
}